import React from 'react';
import allImgPaths from "assets/images";

const ReviewSpaceTaskButton = ({ taskName, count, isCompleted }: any) => {
	return (
		<>
			<button className="flex items-center gap-x-2 bg-[#fff] px-1 py-1 rounded shadow-customShadow9 mb-2 cursor-default">
				<div className="flex items-center gap-x-2 bg-[#F266FF] rounded py-1 px-2">
					<div className="flex items-center gap-x-2">
						<span className="text-white">{taskName}</span>
						<span className="text-white">({count})</span>
					</div>
					<div className="flex items-center gap-x-1 bg-[#ECFDF3] rounded-md border border-[#ABEFC6] py-0.5 px-1">
						{
							isCompleted ?
								<>
									<img src={allImgPaths.completedIcon} alt="completed icon" />
									<span className="text-xs font-interMedium text-[#067647]">Completed</span>
								</> :
								<>
									<img src={allImgPaths.progressIcon} alt="completed icon" />
									<span className="text-xs font-interMedium text-[#067647]">In Progress</span>
								</>
						}
					</div>
				</div>
			</button>
		</>
	)
}

export default ReviewSpaceTaskButton;